const CONTRACT_STATUS = {
    active: 0,
    expired: 1,
} as const;

type ObjectValues<T> = T[keyof T];
type ContractStatusEnum = ObjectValues<typeof CONTRACT_STATUS>;

export {CONTRACT_STATUS, ContractStatusEnum};
